<img
  src="/assets/landing-page/checkmark.png"
  alt=""
     class="h-4"
/>
<p class="text-sm">{{text()}}</p>


